import { adFlag } from '../../config/envsetting'
import { featureFlags } from '../../config/featureFlags'
import * as constant from './constant'

export const PENDING_KEY_PREFIX = 'pendingExitOrderAd_'
export const SHOWN_KEY_PREFIX = 'adDialogShown_ExitOrder_'

function plateKey (plateNumber) {
  return plateNumber || 'unknown'
}

/** 从 hash 路由中解析 code（授权回流兜底） */
export function parseCodeFromHash () {
  const hash = window.location.hash || ''
  const queryStr = hash.split('?')[1] || ''
  if (!queryStr) return ''
  const params = new URLSearchParams(queryStr)
  return params.get('code') || params.get('auth_code') || ''
}

/** URL / hash 是否带有授权回流 code */
export function isOAuthCodeInRoute (vm) {
  const q = vm.$route && vm.$route.query
  if (q && (q.code || q.auth_code)) return true
  return !!parseCodeFromHash()
}

/** 从 URL / 路由 / 本地缓存中清除已失效的微信授权 code，避免 getPayAuthCode 误复用 */
export function clearPayAuthCode (vm) {
  if (vm) {
    vm.code = ''
    if (vm.$store && typeof vm.$store.commit === 'function') {
      vm.$store.commit(constant.keyCodeVuex, '')
    }
    if (vm.saveRouteQueryDataLocal && typeof vm.saveRouteQueryDataLocal === 'object') {
      delete vm.saveRouteQueryDataLocal.code
      delete vm.saveRouteQueryDataLocal.auth_code
      try {
        sessionStorage.setItem(
          constant.keySaveRouteQueryDataVuex,
          JSON.stringify(vm.saveRouteQueryDataLocal)
        )
      } catch (e) {
        // ignore
      }
    }
    const plate = vm.plate_number
    if (plate) {
      try {
        const raw = localStorage.getItem(`urlQueryInfo:${plate}`)
        if (raw) {
          const payload = JSON.parse(raw)
          delete payload.code
          delete payload.auth_code
          localStorage.setItem(`urlQueryInfo:${plate}`, JSON.stringify(payload))
        }
      } catch (e) {
        // ignore
      }
    }
  }
  stripOAuthCodeFromLocation(vm)
}

/** 从 hash 与 vue-router query 中移除 code / auth_code */
export function stripOAuthCodeFromLocation (vm) {
  const hash = window.location.hash || ''
  const parts = hash.split('?')
  const path = parts[0] || hash
  if (parts.length > 1) {
    const params = new URLSearchParams(parts[1])
    if (params.has('code') || params.has('auth_code')) {
      params.delete('code')
      params.delete('auth_code')
      const qs = params.toString()
      const newHash = qs ? `${path}?${qs}` : path
      window.history.replaceState(
        window.history.state,
        '',
        window.location.pathname + window.location.search + newHash
      )
    }
  }
  if (vm && vm.$router && vm.$route) {
    const q = { ...(vm.$route.query || {}) }
    if (q.code || q.auth_code) {
      delete q.code
      delete q.auth_code
      vm.$router.replace({ path: vm.$route.path, query: q }).catch(() => {})
    }
  }
}

/** 获取支付页授权 code */
export function getPayAuthCode (vm) {
  const routeCode = (vm.$route && vm.$route.query && (vm.$route.query.code || vm.$route.query.auth_code)) ||
    parseCodeFromHash() ||
    ''
  if (routeCode) return routeCode

  if (vm.code) return vm.code

  const saved = vm.saveRouteQueryDataLocal || {}
  if (saved.code || saved.auth_code) {
    return saved.code || saved.auth_code
  }
  return ''
}

/** 跳转授权前：标记待展示弹窗，并清除「已展示」标记 */
export function markPendingExitOrderAd (plateNumber) {
  const key = plateKey(plateNumber)
  sessionStorage.setItem(PENDING_KEY_PREFIX + key, '1')
  sessionStorage.removeItem(SHOWN_KEY_PREFIX + key)
  console.log('[ExitOrderPopup] 已标记待展示, plate:', plateNumber)
}

export function clearPendingExitOrderAd (plateNumber) {
  sessionStorage.removeItem(PENDING_KEY_PREFIX + plateKey(plateNumber))
}

export function markExitOrderAdShown (plateNumber) {
  const key = plateKey(plateNumber)
  sessionStorage.setItem(SHOWN_KEY_PREFIX + key, '1')
  clearPendingExitOrderAd(plateNumber)
}

export function hasShownExitOrderAd (plateNumber) {
  return !!sessionStorage.getItem(SHOWN_KEY_PREFIX + plateKey(plateNumber))
}

export function hasPendingExitOrderAd (plateNumber) {
  return !!sessionStorage.getItem(PENDING_KEY_PREFIX + plateKey(plateNumber))
}

/**
 * 是否应展示出口订单弹窗广告
 * @param {Object} vm - 页面实例
 * @param {Object} options
 * @param {boolean} options.allowDirectCode - 页面直接进入且已有 code（无需授权跳转）
 */
export function shouldShowExitOrderAd (vm, { allowDirectCode = false } = {}) {
  if (!featureFlags.popupAd) return false
  if (vm.isCloseADPopup) return false
  if (!getPayAuthCode(vm)) return false
  if (hasShownExitOrderAd(vm.plate_number)) return false
  // 授权回流：URL/hash 已带 code
  if (isOAuthCodeInRoute(vm)) return true
  // 跳转授权前打了 pending
  if (hasPendingExitOrderAd(vm.plate_number)) return true
  return !!allowDirectCode
}

export function showExitOrderAdContent (vm) {
  if (adFlag === '4') {
    if (!vm.$refs.qunfengPopup) {
      return false
    }
    const popup = vm.$refs.qunfengPopup
    if (popup.isPrefetched && popup.isPrefetched()) {
      popup.reveal()
    } else {
      popup.show()
    }
    return true
  }
  vm.showAdDialog = true
  return true
}

/** 进入支付页时预拉取弹窗广告（隐藏挂载，保证曝光；拿到 code 后再展示） */
export function prefetchExitOrderPopup (vm) {
  if (!featureFlags.popupAd || vm.isCloseADPopup) return

  if (adFlag === '4') {
    const tryPrefetch = () => {
      if (vm.$refs.qunfengPopup) {
        vm.$refs.qunfengPopup.prefetch()
        return true
      }
      return false
    }
    if (!tryPrefetch()) {
      vm.$nextTick(() => {
        if (!tryPrefetch()) {
          setTimeout(() => tryPrefetch(), 300)
        }
      })
    }
    return
  }

  vm.popupAdPrefetchMount = true
}

function logSkipReason (vm, { allowDirectCode = false } = {}) {
  console.log('[ExitOrderPopup] 跳过展示', {
    popupAd: featureFlags.popupAd,
    isCloseADPopup: vm.isCloseADPopup,
    hasCode: !!getPayAuthCode(vm),
    routeHasCode: isOAuthCodeInRoute(vm),
    hasShown: hasShownExitOrderAd(vm.plate_number),
    hasPending: hasPendingExitOrderAd(vm.plate_number),
    allowDirectCode,
    plate: vm.plate_number
  })
}

/**
 * 尝试展示出口订单弹窗（带重试与延迟，避免 banner SDK 未就绪）
 */
export function tryShowExitOrderAd (vm, retryCount = 0, options = {}) {
  const { allowDirectCode = false, delayMs = 0 } = options

  const run = () => {
    syncPayAuthCode(vm)

    if (!shouldShowExitOrderAd(vm, { allowDirectCode })) {
      if (retryCount === 0) {
        logSkipReason(vm, { allowDirectCode })
      }
      return
    }

    const tryShow = () => {
      const shown = showExitOrderAdContent(vm)
      if (shown) {
        console.log('[ExitOrderPopup] 弹窗已触发, plate:', vm.plate_number, 'code:', getPayAuthCode(vm).slice(0, 8) + '...')
        markExitOrderAdShown(vm.plate_number)
        return
      }

      if (retryCount < 20) {
        setTimeout(() => tryShowExitOrderAd(vm, retryCount + 1, { ...options, delayMs: 0 }), 300)
      } else {
        console.warn('[ExitOrderPopup] 弹窗组件未就绪，放弃重试')
      }
    }

    if (vm.$nextTick) {
      vm.$nextTick(tryShow)
    } else {
      tryShow()
    }
  }

  if (delayMs > 0) {
    setTimeout(run, delayMs)
  } else {
    run()
  }
}

/** code 就绪后统一调度弹窗 */
export function scheduleExitOrderPopup (vm, options = {}) {
  syncPayAuthCode(vm)
  const allowDirect = options.allowDirectCode !== undefined
    ? options.allowDirectCode
    : (isOAuthCodeInRoute(vm) || hasPendingExitOrderAd(vm.plate_number))

  console.log('[ExitOrderPopup] 调度弹窗, hasCode:', !!getPayAuthCode(vm), 'routeHasCode:', isOAuthCodeInRoute(vm))

  tryShowExitOrderAd(vm, 0, {
    allowDirectCode: allowDirect,
    delayMs: options.delayMs !== undefined ? options.delayMs : 1500
  })

  // 兜底：banner / 券包 SDK 初始化较慢时再试一次
  tryShowExitOrderAd(vm, 0, {
    allowDirectCode: allowDirect,
    delayMs: 3500
  })
}

/** 保存完整订单参数，供 CodeObtain 授权回流使用 */
export function saveUrlQueryForCodeObtain (vm) {
  const plate = vm.plate_number || (vm.$route.query && vm.$route.query.plate_number)
  if (!plate) return

  const routeQuery = vm.$route.query || {}
  const payload = routeQuery.localInfo !== undefined
    ? routeQuery
    : {
      ...(vm.saveRouteQueryDataLocal || {}),
      plate_number: plate
    }

  localStorage.setItem(`urlQueryInfo:${plate}`, JSON.stringify(payload))
}

/** 同步 vm.code（created / mounted 调用） */
export function syncPayAuthCode (vm) {
  const code = getPayAuthCode(vm)
  if (code) {
    vm.code = code
  }
  return code
}
